
const accountPayable        = require ('./clientPayments-report-account-payable')
const accountReceivable        = require ('./clientPayments-report-account-receivable')

export function start(detail){  //console.log('goku-dt 5>', detail)
      obj[detail.reportType].start(detail)

}/**/

const obj = {
   accountPayable:     { start: (detail)=>{  accountPayable.start(detail)  }},
   accountReceivable:     { start: (detail)=>{  accountReceivable.start(detail)  }},
}


//Account Receivable 